import type { ModalMapType } from "../../../../../common-deprecated/types/CommonTypes";
import { MODAL_USC_FORM } from "../../../../shared-logic/utils/integrated-modal/integratedModalConstants";
import IntegratedUscFormModal from "../../../../shared-components/lexus/floating-elements/modals/integrated-modal/IntegratedUscFormModal";
import TyreInfoModal from "../../../../shared-components/lexus/floating-elements/modals/tyre-info/TyreInfoModal";
import MobileNavCtaModal from "./MobileNavCtaModal";
import UscBasketDetailsModal from "./UscBasketDetailsModal";
import type { UscModalIdsType } from "../../../utils/modalConstants";
import {
    MODAL_USC_BASKET_DETAILS,
    MODAL_USC_CAR_DELIVERY,
    MODAL_USC_CAR_DELIVERY_INFO,
    MODAL_USC_DEBUG,
    MODAL_USC_DISCOVER_YOUR_CAR,
    MODAL_USC_MOBILE_NAV_CTA,
    MODAL_USC_THREE_SIXY_SPIN,
} from "../../../utils/modalConstants";
import DiscoverYourCarModal from "./DiscoverYourCarModal";

import { MODAL_USC_INJECTION, MODAL_VEHICLE_FOR_SALE_ID } from "../../../../shared-logic/utils/modalConstants";
import UscDebugModal from "./UscDebugModal";
import UscThreeSixtySpinModal from "./UscThreeSixtySpinModal";
import UscCarDeliveryInfoModal from "./UscCarDeliveryInfoModal";
import VehicleForSaleIdModal from "../../../../shared-components/lexus/floating-elements/modals/vehicle-for-sale-id-modal/VehicleForSaleIdModal";
import type { MODAL_CONTENT } from "../../../../../common-deprecated/utils/modalConstants";
import UscCarDeliveryModal from "./UscCarDeliveryModal";
import UscInjectionModal from "./UscInjectionModal";
import { uscLexusModalMap } from "../../../../shared-components/lexus/floating-elements/modals/modals";
import { MODAL_TYRE_INFO } from "../../../../../shared-logic/utils/tyreInfoContants";

export const aemLexusUscModalMap: ModalMapType<UscModalIdsType & typeof MODAL_CONTENT> = {
    ...uscLexusModalMap,
    [MODAL_USC_INJECTION]: UscInjectionModal,
    [MODAL_USC_DEBUG]: UscDebugModal,
    [MODAL_USC_MOBILE_NAV_CTA]: MobileNavCtaModal,
    [MODAL_USC_DISCOVER_YOUR_CAR]: DiscoverYourCarModal,
    [MODAL_USC_FORM]: IntegratedUscFormModal,
    [MODAL_TYRE_INFO]: TyreInfoModal,
    [MODAL_USC_THREE_SIXY_SPIN]: UscThreeSixtySpinModal,
    [MODAL_USC_CAR_DELIVERY_INFO]: UscCarDeliveryInfoModal,
    [MODAL_USC_CAR_DELIVERY]: UscCarDeliveryModal,
    [MODAL_USC_BASKET_DETAILS]: UscBasketDetailsModal,
    [MODAL_VEHICLE_FOR_SALE_ID]: VehicleForSaleIdModal,
};
